"use strict";

var _slicedToArray = require("/home/circleci/repo/web_client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

var useDebounce = function useDebounce(fn) {
  var ms = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var args = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  var _react_1$useState = react_1.useState(null),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      timeout = _react_1$useState2[0],
      setTimeoutVar = _react_1$useState2[1];

  react_1.useEffect(function () {
    // if args change then clear timeout
    clearTimeout(timeout);
    var t = setTimeout(fn.bind(null, args), ms);
    setTimeoutVar(t);
  }, args);
};

exports.default = useDebounce;